import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import AdminLayout from "./layouts/AdminLayout";
import BDELayout from "./layouts/BDELayout";
import HRLayout from "./layouts/HRLayout";
import Leads from "./pages/Leads";
import Attendance from "./pages/Attendance";
import Payments from "./pages/Payments";
import HRAttendance from "./pages/HRAttendance";
import HREmployees from "./pages/AccessManagement";
import AdminLeaveManagement from "./pages/AdminLeaveManagement";
import HrLeaveManagement from "./pages/HrLeaveManagement";
import EmployeeLeaveManagement from "./pages/EmployeeLeaveManagement";
import ApprovalConsole from "./pages/ApprovalConsole";
import AddEmployeeForm from "./pages/AddEmployee";
import MyProfile from "./pages/MyProfile";
import ProtectedRoute from "./routes/ProtectedRoute";
import SalesToolkit from "./pages/SalesToolkit";
// ⚙️ IMPORT THE NEW SETTINGS PAGE COMPONENT
import Settings from "./pages/Settings";
import ManageEmployees from "./pages/ManageEmployees";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* ADMIN */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="leads" replace />} />
          <Route path="leads" element={<Leads />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="hr-attendance" element={<HRAttendance />} />
          <Route path="employees" element={<HREmployees />} />
          <Route path="add-employee" element={<AddEmployeeForm />} />
          <Route path="payments" element={<Payments />} />
          <Route path="leaves" element={<AdminLeaveManagement />} />
          <Route path="manage-employees" element={<ManageEmployees />} />
          <Route path="profile" element={<MyProfile />} />
          <Route path="toolkit" element={<SalesToolkit />} />
          {/* 🔒 ADMIN SETTINGS SUBROUTE */}
          <Route path="settings" element={<Settings />} />
          <Route
            path="approvals"
            element={<ApprovalConsole role="Manager" />}
          />
        </Route>

        {/* BDE */}
        <Route
          path="/bde"
          element={
            <ProtectedRoute allowedRoles={["BDE"]}>
              <BDELayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="leads" replace />} />
          <Route path="leads" element={<Leads />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="my-leaves" element={<EmployeeLeaveManagement />} />
          <Route path="profile" element={<MyProfile />} />
          <Route path="payments" element={<Payments />} />
          <Route path="toolkit" element={<SalesToolkit />} />
          {/* 🔒 BDE SETTINGS SUBROUTE */}
          <Route path="settings" element={<Settings />} />
        </Route>

        {/* HR */}
        <Route
          path="/hr"
          element={
            <ProtectedRoute allowedRoles={["HR"]}>
              <HRLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="leads" replace />} />
          <Route path="leads" element={<Leads />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="hr-attendance" element={<HRAttendance />} />
          <Route path="employees" element={<HREmployees />} />
          <Route path="add-employee" element={<AddEmployeeForm />} />
          <Route path="leaves" element={<HrLeaveManagement />} />
          <Route path="profile" element={<MyProfile />} />
          <Route path="toolkit" element={<SalesToolkit />} />
          <Route path="manage-employees" element={<ManageEmployees />} />
          {/* 🔒 HR SETTINGS SUBROUTE */}
          <Route path="settings" element={<Settings />} />
          <Route path="approvals" element={<ApprovalConsole role="HR" />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
